<div class="h-100 ui-obj-table">
    <div class="ui-header d-flex align-items-center mb-2 border-bottom">
        <div class="flex-grow-1 d-flex">
            <input type="checkbox" [(ngModel)]="isSelectAll" (change)="onSelectAllRows($event)">
            <span> Select All </span>
        </div>

        <button class="btn btn-danger btn-sm mx-2" (click)="onDelete()">
            <img src="assets/images/virtusa-icons/delete-red.svg" alt="Delete Icon" width="14" height="16" class="me-1">
            Delete
        </button>
        <button class="btn btn-primary btn-sm" (click)="onEdit()">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.06 4.2L15.8 6L8.5 13.3H6.7V11.5L14.06 4.2M14.06 2.5C13.8 2.5 13.54 2.6 13.35 2.8L2.1 14.05C1.92 14.24 1.82 14.5 1.82 14.77V16.7C1.82 17.12 2.16 17.46 2.58 17.46H4.51C4.78 17.46 5.04 17.36 5.23 17.17L16.48 5.92C16.67 5.73 16.77 5.47 16.77 5.2C16.77 4.93 16.67 4.67 16.48 4.48L14.54 2.54C14.35 2.35 14.08 2.25 13.81 2.25L14.06 2.5Z" fill="currentColor"/>
            </svg>
            Edit
        </button>
    </div>
    <div class="ui-body">
        <app-zorro-table [columns]="tableData.columns" [data]="tableData.items" (onRowSelect)="onTableRowSelect($event)"></app-zorro-table>
    </div>
</div>
